<template>
  <div>
    <b-row>
      <b-col class="mt-3">
        <b-btn
          class="m-1"
          size="sm"
          variant="info"
          pill
          @click="fetchData(getThisYearRange)"
        >
          {{ this.getThisYearRange[0].substring(0, 4) }}
        </b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-3">
        <b-btn
          v-for="(item, index) in brandsArray"
          :key="index"
          class="m-1"
          size="sm"
          variant="info"
          pill
          @click="fetchBrandData(item, getThisYearRange)"
        >
          {{ item }}
        </b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <stacked-line-chart
          :chart-data="chartData"
          style="height: 400px; postition: relative;"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    "stacked-line-chart": () =>
      import("@/components/common/charts/FinanceLineChart.vue"),
  },
  data() {
    return {
      chartData: {},
      brandsArray: [
        "all",
        "finnik",
        "national_netherlands",
        "cartracker",
        "imoto",
        "traksi",
        "ulubv",
        "ulu",
        "uluuk",
        "fleetify"
      ]

    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    fetchData(range) {
      const data = {
        query: `
          query  {
            RevenueArrDetails(
              from: "${range[0]}",
              to: "${range[1]}"
            )
          }
        `
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.chartData = JSON.parse(res.RevenueArrDetails)
        }
      }).finally(() => {
        this.setShowLoadingModal(false);
      })
    },
    fetchBrandData(brand, range) {
      const data = {
        query: `
          query  {
            RevenueArrDetails(
              from: "${range[0]}",
              to: "${range[1]}",
              brand: "${brand}"
            )
          }
        `
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.chartData = JSON.parse(res.RevenueArrDetails)
        }
      }).finally(() => {
        this.setShowLoadingModal(false);
      })
    }
  },
  computed: {
    ...mapGetters([
      "getThisYearRange",
      "getUserSystem"
    ])
  },
  watch: {
    getUserSystem: function() {
      this.fetchData(this.getThisYearRange);
    }
  },
  mounted() {
    this.fetchData(this.getThisYearRange);
  }
};
</script>
